import { Divider, Paper, Stack, Typography } from "@mui/material";
import TemplateSettingField from "./components/TemplateSettingField";
import { useFormikContext } from "formik";
import { OrganizationWebsite } from "@/pages/organization-website/OrganizationWebsite";

const TemplateSettings = () => {
    const { values, setFieldValue } = useFormikContext<OrganizationWebsite>();

    const handleChange = (field: string, value: any) => {
        const setting = values.settings?.[field] ?? {};
        setFieldValue(`settings.${field}`, { ...setting, value });
    }

    const settings = values?.settings ? Object.entries(values.settings) : [];
    
    return (
        <Paper sx={{ padding: 2 }}>
            <Stack gap={2}>
                <Typography variant="h4">Configuraciones de la plantilla</Typography>
                {settings.map(([fieldId, field], fieldIndex) => (
                    <Stack spacing={3} key={fieldId}>

                        <TemplateSettingField {...field} id={fieldId} onChange={handleChange} />

                        {(settings.length - 1) !== fieldIndex ? (
                            <Divider/>
                        ) : null}
                    </Stack>
                ))}
            </Stack>
        </Paper>
    )
}

export default TemplateSettings;
